<template>
  <div id="user-profile">
    <div class="container">
      <h1>{{ user.name }}</h1>
      <p class="lead">{{ user.company }}</p>
    </div><!-- /.container -->
  </div><!-- /#user-profile -->
</template>

<script>
import firebase from 'firebase'
const db = firebase.firestore()


export default {
  data() {
    return {
      user: ''
    }
  },
  created () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      let self = this;
      var docRef = db.collection("users").doc(this.$route.params.id);
      docRef.get().then(function(doc) {
        if (doc.exists) {
          self.user = doc.data()
        }
      }).catch(function(error) {
          console.log("Error getting document:", error);
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserProfile.vue